import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const COULEURS = {
  active: "bg-emerald-500",
  pending: "bg-amber-500",
  paused: "bg-slate-400",
  done: "bg-slate-300",
};

export default function MobileProjectsPage() {
  const navigate = useNavigate();
  const token = localStorage.getItem("odo_studio_token");
  const [projets, setProjets] = useState([]);
  const [chargement, setChargement] = useState(true);

  useEffect(() => {
    if (!token) return;
    (async () => {
      const r = await fetch(`${API_URL}/api/projects`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (r.ok) {
        const liste = await r.json();
        liste.sort((a, b) => {
          if (a.status === b.status) return (a.name || "").localeCompare(b.name || "");
          return a.status === "active" ? -1 : b.status === "active" ? 1 : 0;
        });
        setProjets(liste);
      }
      setChargement(false);
    })();
  }, [token, navigate]);

  return (
    <div className="min-h-[100dvh] bg-[#faf9f7] text-[#1a1a1a]">
      <header
        className="sticky top-0 z-10 border-b border-black/5 bg-[#faf9f7]/90 px-5 backdrop-blur"
        style={{ paddingTop: "calc(max(env(safe-area-inset-top), 44px) + 10px)", paddingBottom: "12px" }}
      >
        <div className="flex items-start justify-between gap-3">
          <div>
            <h1 className="text-[26px] font-semibold tracking-tight">Projets</h1>
            <p className="mt-0.5 text-[13px] text-black/45">
              {chargement ? "chargement…" : `${projets.length} projets`}
            </p>
          </div>
          <button
            onClick={() => navigate("/m/agents")}
            className="rounded-full bg-[#1a1a1a] px-3 py-2 text-[13px] font-semibold text-white active:scale-[0.98]"
            style={{ touchAction: "manipulation" }}
          >
            Nuage agents
          </button>
        </div>
      </header>

      <div
        className="px-4 pt-3"
        style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 24px)" }}
      >
        {projets.map((p) => (
          <button
            key={p.id}
            onClick={() => navigate(`/m/projet/${p.id}`)}
            className="mb-2 flex w-full items-center gap-3 rounded-2xl border border-black/5 bg-white px-4 py-3.5 text-left transition-transform active:scale-[0.985]"
            style={{ touchAction: "manipulation" }}
          >
            <span
              className={`h-2 w-2 shrink-0 rounded-full ${COULEURS[p.status] || "bg-slate-300"}`}
            />
            <span className="min-w-0 flex-1">
              <span className="block truncate text-[16px] font-medium leading-tight">
                {p.name}
              </span>
              <span className="mt-0.5 block truncate text-[13px] text-black/45">
                {p.current_stage || p.status || "—"}
              </span>
            </span>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="shrink-0 text-black/20"
            >
              <path d="M9 18l6-6-6-6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        ))}

        {!chargement && projets.length === 0 && (
          <div className="mt-24 text-center text-[15px] text-black/40">Aucun projet.</div>
        )}
      </div>
    </div>
  );
}
